import { Action, createReducer, on } from '@ngrx/store';
import { AppConfigState, initialState } from './config.state';

import * as ConfigActions from './config.action';

const appConfigReducer = createReducer(
  initialState,
  on(ConfigActions.hideHeader, (state) => {
    return {
      ...state,
      hideHeader: true,
    };
  }),
  on(ConfigActions.showHeader, (state) => {
    return {
      ...state,
      hideHeader: false,
    };
  }),
  on(ConfigActions.hideMobileDock, (state) => {
    return {
      ...state,
      hideMobileDock: true,
    };
  }),
  on(ConfigActions.showMobileDock, (state) => {
    return {
      ...state,
      hideMobileDock: false,
    };
  }),
  on(ConfigActions.hideFooter, (state) => {
    return {
      ...state,
      hideFooter: true,
    };
  }),
  on(ConfigActions.showFooter, (state) => {
    return {
      ...state,
      hideFooter: false,
    };
  })
);

export function reducer(state: AppConfigState | undefined, action: Action) {
  return appConfigReducer(state, action);
}
